import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Eye, ShieldCheck } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";
import LegalFooter from "../components/LegalFooter";

export default function Welcome() {
  const { theme, toggle } = useTheme();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground" data-testid="welcome-screen">
      <header className="flex items-center justify-between px-6 py-5">
        <span className="brand-wordmark text-sm text-foreground">FINALLOOK</span>
        <button
          onClick={toggle}
          data-testid="welcome-theme-toggle"
          className="p-2 rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
      </header>

      <main className="flex-1 flex flex-col justify-center px-6 pb-16 hero-noise">
        <div className="max-w-xl mx-auto w-full">
          <div className="inline-flex items-center gap-2 pill-tag mb-8" data-testid="welcome-tag">
            <ShieldCheck className="h-3.5 w-3.5 text-primary" />
            <span>Private communication review</span>
          </div>

          <h1 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6" data-testid="welcome-brand">
            FINAL<span className="text-primary">LOOK</span>
          </h1>

          <p className="font-heading text-xl sm:text-2xl text-foreground/90 mb-4 leading-snug" data-testid="welcome-tagline">
            Before you send it, give it one <span className="text-primary">FINALLOOK</span>.
          </p>

          <p className="text-base text-muted-foreground leading-relaxed mb-10 max-w-md" data-testid="welcome-description">
            See how your message may be received before you hit send.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/signup" className="sm:flex-1">
              <Button
                size="lg"
                className="w-full rounded-full h-12 text-base font-semibold bg-primary hover:bg-primary/90 text-primary-foreground"
                data-testid="welcome-get-started-btn"
              >
                Get Started
                <Eye className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/signin" className="sm:flex-1">
              <Button
                size="lg"
                variant="outline"
                className="w-full rounded-full h-12 text-base font-semibold border-border"
                data-testid="welcome-sign-in-btn"
              >
                Sign In
              </Button>
            </Link>
          </div>

          <p className="mt-10 text-xs text-muted-foreground max-w-md">
            FINALLOOK never makes the send decision for you. Your message stays yours — we just help you see it more clearly.
          </p>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
